import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ScrollToBottom from 'react-scroll-to-bottom';
import { Col, Row, Button } from 'reactstrap';
import socketIOClient from 'socket.io-client';
import CustomModal from '../../../../CustomModal';
import CustomSelectionRec from '../../../../CustomSelectionRec';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import logoLoading from '../../../../../Res/logo-loading.gif';
import stripAnsi from 'strip-ansi';
import {
  checkWatchguardIsActive,
  fetchDiagnosticReport,
  refreshDiagnosticResults,
  restartWatchguard,
  downloadRecMenulogs,
  getFailoverOptions
} from '../../../../../actions/EpikBoxes';
import { dataCenterShellUrls } from '../../../BoxOverview';
import fetchLogo from '../../../../../Res/Icon/Fetch-Results.svg'
import vSwitchLogo from '../../../../../Res/Icon/vSwitch-Output-new.svg'
import nocLogo from '../../../../../Res/Icon/NOC.svg'

import runDiagnosticLogo  from '../../../../../Res/Icon/arrow-down-to-line-solid.svg'
import recButtonLogo from '../../../../../Res/Icon/REC-Button.svg'
import interfaceFailOver from '../../../../../Res/svg/failOverOptions.svg'
import TooltipIcon from '../../TooltipIcon/TooltipIcon';
import XmlViewer from '../../../../xmlViewer';
import { ReactComponent as LoadingIcon} from '../../../../../Res/loadingSpinner.svg';
import { FAILOVER_COMMANDS, DEVICE_LOCK_BY_SOMEONE } from '../../../../../lib/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons'
import ConfirmationModal from '../../../../ConfirmationModal';
import addNote from '../../../../../lib/api/addNote';
import utils from '../../../../../lib/utils';
import { toast } from 'react-toastify';
import { getPermissionForComponent } from '../../../../../utils/permissionsUtils';
import FailoverOptionsModalClassic from './failoverInterface'
import { useUnifiedFetch } from '../../../../../hooks';
import SpinnerCircles from '../../../../../../src/components/Spinner/SpinerCircles';
import './style.css'
let testingArray = []
let testingObject = {}
let selectedCmd = ''
const Diagnostics = ({ boxDetails, user }) => {
  const token = localStorage.getItem('jwtToken') || null;

  const { 
    isLoading: isStatusLoading, 
    data: deviceStatus, 
    fetchData: fetchDeviceCdmStatus 
  } = useUnifiedFetch(`boxes/cdm-box-status/${boxDetails?.serialNumber}`, false);

  const dispatch = useDispatch();

  const [diagRes, setDiagRes] = useState([]);
  const [fetchTest, setFetchTest] = useState(false);
  const [watchguardCheck, setWatchguardCheck] = useState(false);
  const [stateSocket, setStateSocket] = useState(null);
  const [rceModal, setRceModal] = useState(false);
  const [commandList, setCommandList] = useState([]);
  const [selectedDiscription, setSelectedDiscription] = useState('');
  const [selectedCommand, setSelectedCommand] = useState('');
  const [commandDataList, setCommandDataList] = useState([]);
  const [recMoreOptions, setRecMoreOptions] = useState([]);
  const [recSubCommand, setRecSubCommand] = useState('');
  const [modalStatus, setModalStatus] = useState(false);
  const [isFsCli, setIsFsCli] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [noDiagLogs, setnoDiagLogs] = useState('No diagnostics logs found!');
  const [recLoading, setRecLoading] = useState(false);
  const [scrollBottom, setScrollBottom] = useState(true)
  const [showScrollBtn, setShowScrollBtn] = useState(false)
  const [isWatchguardLoading, setIsWatchGuardLoading] = useState(false)
  const [commandDataListSide, setCommandDataListSide] = useState([]);
  const [isFailoverOpen, setIsFailoverOpen] = useState(false);
  const [foData, setFoData] = useState({loading: true ,failOverOptions:null});
  const messageRef = useRef();

  const startRef = useRef();
  const recParentRef = useRef();
  const endRef = useRef();
  const [dcUpdatePopup, setDcUpdatePopup] = useState({ show: false, value: {} });
  const lockStatusBox = useSelector(state => state.UIState.epikBoxes.lockStatusEpikBox);
  const serialNumberDash = `${boxDetails.serialNumber}-${user._id}`;
  const recDiagnostics = getPermissionForComponent('recDiagnostics',user.permissionsGroup);
  const canAccessContainerRebuild =
    getPermissionForComponent('containerRebuild', user.permissionsGroup) ||
    user.epikEngineering === true;
  const [downloadLoadingStatus, setdownloadLoadingStatus] = useState(false)
  const [isPreparingDownload, setIsPreparingDownload] = useState(false);
  const [preparingDownloadCommand, setPreparingDownloadCommand] = useState('');
  const [sideBySideData, setSideBySideData] = useState({
    dc: '',
    wg: '',
  });
  const downloadDataRef = useRef({});
  const downloadTimeoutRef = useRef(null);
  const {REACT_APP_NOCWIZARD_SERVER } = process.env
  const nocWizardAccess = getPermissionForComponent('nocWizardAccess',user.permissionsGroup);
  const failOverOptions = getPermissionForComponent('failOverOptions',user.permissionsGroup);

  useEffect(() => {
    if (boxDetails?.vpnAddress && utils.checkBoxVersionThirdOctet(boxDetails?.vpnAddress) !== 'v2') {
      fetchDeviceCdmStatus()
    }
  }, [boxDetails?.vpnAddress])
  const openFailoverWithData = async () => {
    const el = document.getElementById('test-time-remaining');
    const hidden = el?.getAttribute('hidden') !== null;
    if (lockStatusBox?.locked) {
      toast.error(DEVICE_LOCK_BY_SOMEONE);
      return;
    }
    if (hidden) {
      setDcUpdatePopup({ show: true });
      return;
    }
    if (!boxDetails.apiOnline) {
      toast.error('Edge Device Offline or Unreachable');
      return
    }
    try {
      const [failOverOptions] = await Promise.all([
        dispatch(getFailoverOptions(token, boxDetails._id)).unwrap?.() ?? dispatch(getFailoverOptions(token, boxDetails._id)),
      ]);
      setFoData(prev => ({
        ...prev,
        failOverOptions,
        loading: false,
      }));
        } catch (e) {
          setFoData(prev => ({
            ...prev,
            failOverOptions: null,
            loading: false,
          }));
          }
      setIsFailoverOpen(true);
  };
  const onRefreshFailOverOptions = async () => {
    const el = document.getElementById('test-time-remaining');
    const hidden = el?.getAttribute('hidden') !== null;
    if (lockStatusBox?.locked) {
      toast.error(DEVICE_LOCK_BY_SOMEONE);
      return;
    }
    if (hidden) {
      setDcUpdatePopup({ show: true });
      return;
    }
    try {
      const [failOverOptions] = await Promise.all([
        dispatch(getFailoverOptions(token, boxDetails._id)).unwrap?.() ?? dispatch(getFailoverOptions(token, boxDetails._id)),
      ]);
      setFoData(prev => ({
        ...prev,
        failOverOptions,
        loading: false,
      }));
    } catch (e) {
      setFoData(prev => ({
        ...prev,
        failOverOptions: null,
        loading: false,
      }));
    }
  };

  const commandsForDeviceActivityLog = {
    reboot: 'Soft Reboot Epik Box',
    epik_util: {
      power_cycle: 'POWER Cycle Reboot Epik Box'
    },
    'EPI controls ATA': {
      hard_reboot_ata: 'Hard Reboot Epik Box ',
      soft_restart_ata: 'Soft Reboot Epik Box '
    }
  };

  useEffect(() => {
    if (messageRef.current) {
      messageRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'end',
        inline: 'nearest',
      });
    }
  });

  useEffect(() => {
    const request = async () => {
      if (isFsCli !== null) {
        await rceRequest(isFsCli);
      }
    }
    request()
  }, [isFsCli])

  const unLockBoxButton = async () => {
    const element = document.getElementById('test-lock-icon');
    if (element) {
      // Simulate a click event
      element.click();
    } else {
      console.error('Element with id "test-lock-icon" not found.');
    }
 
  };

  const rceRequest = async () => {
    // const serialNumberDash = isFsCli ? serialNumberDashVSwitch : serialNumberDash
    const baseUrl = dataCenterShellUrls[boxDetails.datacenter];
    const socket = socketIOClient.connect(baseUrl, { query: { token } });
    socket.on('connect', async () => {
      socket.emit('RCE', {
        serialNumber: serialNumberDash,
        command: 'getList',
        ip: boxDetails.vpnAddress,
      });
      setStateSocket(socket);
      await new Promise(resolve => {
        socket.on(`rce-${serialNumberDash}-list`, data => {
          if (data.commands.length > 0) {
            const filteredCommands = (data.commands || []).map(cmd => {
              if (!cmd.moreOptions) return cmd;
              return {
                ...cmd,
                moreOptions: cmd.moreOptions.filter(
                  opt =>
                    opt.name !== 'container_rebuild' || canAccessContainerRebuild
                ),
              };
            });
            !isFsCli && setCommandList(filteredCommands);
            setRecMoreOptions([]);
            if (modalStatus) {
              setSelectedCommand(filteredCommands[0]);
              setSelectedDiscription(filteredCommands[0].description);
              setModalStatus(false);
              setRceModal(true);
            }
            resolve();
          }
        });
      });
      if (isFsCli) {
        selectedCmd = 'active_call_monitoring'
        onRunCommand(
          { name: 'active_call_monitoring', description: 'Active Call Monitoring' },
          socket,
        );
      }
    });
  };

  const downloadLogs = (command, logs, ext = 'txt') => {
    // Define MIME types for different extensions
    const mimeTypes = {
      txt: 'text/plain;charset=utf-8',
      csv: 'text/csv;charset=utf-8',
      json: 'application/json;charset=utf-8',
      log: 'text/plain;charset=utf-8',
      xml: 'application/xml;charset=utf-8',
    };
  
    // Default to 'text/plain' if the extension is not recognized
    const mimeType = mimeTypes[ext] || 'text/plain;charset=utf-8';
  
    // Create a Blob with the appropriate MIME type
    const blob = new Blob([logs], { type: mimeType });
    const url = URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = `${command}_${new Date().toISOString()}.${ext}`;
    document.body.appendChild(a);
    a.click();
  
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  
    console.log("Log file downloaded successfully");
  };  
  const handleSideBySidePingData = data => {
    const { command, output } = data;
      const safeOutput = cleanOutput(output); 
    // const safeOutput = String(output);
    let returningData;
    setSideBySideData(prev => {
      let { dc, wg } = prev;
      if (typeof dc !== 'string') dc = dc ? String(dc) : '';
      if (typeof wg !== 'string') wg = wg ? String(wg) : '';
      if (command === 'side_by_side_ping_dc') {
        if (dc.includes(safeOutput)) {
          return prev;
        }
        return {
          ...prev,
          dc: dc + '\n' + safeOutput,
        };
      } else if (command === 'side_by_side_ping_wg') {
        if (wg.includes(safeOutput)) {
          return prev;
        }
        // Otherwise, append
        return {
          ...prev,
          wg: wg + '\n' + safeOutput,
        };
      }
      returningData = prev;
      return prev;
    });
    return returningData;
  };
  const rceDataRequest = socket => {
    const ssocket = socket ? socket : stateSocket;
    if (!ssocket) console.log('socket instance error ');
    ssocket &&
      ssocket.on(`rce-${serialNumberDash}-command`, data => {
        setRecLoading(false);

        // Handle download commands - accumulate data and download only when complete
        if (data?.command === 'download_local_cdr' || data?.command === 'vswitch_logs') {
          const command = data.command;
          
          // Initialize or accumulate data for this command
          if (!downloadDataRef.current[command]) {
            downloadDataRef.current[command] = '';
            // Set preparing download state when first data chunk arrives
            setIsPreparingDownload(true);
            setPreparingDownloadCommand(command);
          }
          downloadDataRef.current[command] += data.output || '';
          
          // Clear existing timeout
          if (downloadTimeoutRef.current) {
            clearTimeout(downloadTimeoutRef.current);
          }
          
          // Set a new timeout - if no new data comes in for 1 second, assume request is complete
          downloadTimeoutRef.current = setTimeout(() => {
            const accumulatedData = downloadDataRef.current[command];
            if (accumulatedData) {
              downloadLogs(command, accumulatedData, command === 'vswitch_logs' ? 'log' : 'csv');
              // Clear the accumulated data after download
              downloadDataRef.current[command] = '';
              // Clear preparing download state
              setIsPreparingDownload(false);
              setPreparingDownloadCommand('');
            }
            downloadTimeoutRef.current = null;
          }, 1000);
          
          // Continue processing for display - don't return early
        }
        let sideBySide;
        if (data?.command === 'side_by_side_ping_dc' || data?.command === 'side_by_side_ping_wg') {
          sideBySide = handleSideBySidePingData(data);
        }
        if (testingArray.length === 0 && selectedCmd) {
          testingArray.push(data.output);
          // testingObject = { ...testingObject, [data.command]: data.output };
          testingObject = {
            ...testingObject,
            [data.command]: {
              label: data.label || data.command,
              output: data.output || ''
            }
          };
          let keys = Object.keys(testingObject);
          let newArr = [];
          keys.map(ob => {
            // let i = { command: ob, label: data.label,output: sideBySide ? sideBySide : testingObject[ob] };
            let i = {
              command: ob,
              label: testingObject[ob]?.label || ob,
              output: sideBySide ? sideBySide : (testingObject[ob]?.output || '')
            };
            newArr.push(i);
          });
          setCommandDataList([...newArr]);
        } else if (!testingArray.includes(data.output)) {
          // console.log("updating commanda commandDataList.length ", commandDataList.length)
          testingArray.push(data.output);
          if (selectedCmd == data.command) {
            let newArr = [];
            let keys = Object.keys(testingObject);
            if (keys.includes(data.command)) {
              // testingObject = {
              //   ...testingObject,
              //   [data.command]: testingObject[data.command].concat(data.output),
              // };
              testingObject = {
                ...testingObject,
                [data.command]: {
                  label: (testingObject[data.command]?.label) || data.label || data.command,
                  output: (testingObject[data.command]?.output || '').concat(data.output || '')
                }
              };
            } else {
              testingObject = { ...testingObject, [data.command]: data.output };
            }
            keys.map(ob => {
              // let i = { command: ob, label: data.label, output: sideBySide ? sideBySide : testingObject[ob] };
              let i = {
                command: ob,
                label: testingObject[ob]?.label || ob,
                output: sideBySide ? sideBySide : (testingObject[ob]?.output || '')
              };
              newArr.push(i);
            });
            setCommandDataList([...newArr]);
          } else {
            console.log(
              ' command =============not matched==============',
              selectedCmd,
              data.command,
            );
          }
        }
      });
  };

  const onRunCommand = (a, socket) => {
    setRecLoading(true)
    testingArray = []
  // const serialNumberDash = isFsCli ? serialNumberDashVSwitch : serialNumberDash

    // Clear any pending download timeouts and reset download data
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
      downloadTimeoutRef.current = null;
    }
    downloadDataRef.current = {};
    setIsPreparingDownload(false);
    setPreparingDownloadCommand('');
    setSideBySideData({ dc: '', wg: '' });

    let command = isFsCli ? { name: 'active_call_monitoring', description: 'Active Call Monitoring' } : recMoreOptions.length ? recSubCommand : selectedCommand;
    console.log({ command })
    addActivityLogForCommands(commandsForDeviceActivityLog,selectedCommand?.name,recSubCommand?.name )
    selectedCmd = command.name
    let ssocket = socket ? socket : stateSocket;
    if (command) {
      ssocket.emit('RCE', {
        serialNumber: serialNumberDash,
        command: command,
        ip: boxDetails.vpnAddress,
        rec: true
      });
      setTimeout(() => {
        rceDataRequest(ssocket);
      }, 100)
    }
  };

  const onCommandListChange = (e) => {
    const { value } = e.target;
    if (!value) {
      setSelectedCommand(null);
      setRecMoreOptions([]);
      setRecSubCommand(null);
      setSelectedDiscription('');
      return;
    }

    const selectedItem = commandList.find(x => x.name === value);
    if (!selectedItem) return;

    setSelectedCommand(selectedItem);
    setCommandDataListSide([]);
    selectedCmd = selectedItem.name;

    if (selectedItem.moreOptions?.length) {
      const firstOption = selectedItem.moreOptions[0];
      setRecMoreOptions(selectedItem.moreOptions);
      setRecSubCommand(firstOption);
      setSelectedDiscription(firstOption.description);
      selectedCmd = firstOption.name;
    } else {
      setRecMoreOptions([]);
      setRecSubCommand(null);
      setSelectedDiscription(selectedItem.description);
    }
  };

  const onRecSubCommandChange = (e) => {
    const { value } = e.target;
    const selectedItem = recMoreOptions.find(x => x.name === value);
    if (!selectedItem) return;

    setRecSubCommand(selectedItem);
    setSelectedDiscription(selectedItem.description);
    selectedCmd = selectedItem.name;
  };

  const onClearRce = () => {
    setCommandDataList([]);
    testingArray = []
    testingObject = {};
    selectedCmd = ''
    setCommandDataListSide([]); // Clear the side-by-side data
    setSideBySideData({ dc: '', wg: '' });
    
    // Clear any pending download timeouts and reset download data
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
      downloadTimeoutRef.current = null;
    }
    downloadDataRef.current = {};
    setIsPreparingDownload(false);
    setPreparingDownloadCommand('');
   };

  const renderCommandList = (
    <>
      <h1>Command</h1>
      <div className="header-rce">
        <CustomSelectionRec
          onChange={onCommandListChange}
          optionsList={commandList}
          defaultOpt={true}
          value={selectedCommand}
          width="250px"
          isClearable
        />
        {recMoreOptions?.length > 0 && (
          <CustomSelectionRec
            onChange={onRecSubCommandChange}
            optionsList={recMoreOptions}
            value={recSubCommand}
            width="250px"
            isClearable
          />
        )}
        <div className="command-text-container">
          <h1 className="command-list-text">{selectedDiscription}</h1>
        </div>
      </div>
    </>
  );

  const item = [
    { name: "lte_24_hour_log", value: "LTE24hr_Logs" ,downloadName : "LTE_24_hour_log"},
    { name: "review_failover_log", value: "Failover_Logs" , downloadName:"Review_failover_log"},
    { name: "review_full_watchguard_log", value: "WatchGuard_Logs" ,downloadName:'Review_full_watchguard_log' },
    { name: "lte_manager_log", value: "LTE_Manager_Logs" ,downloadName : "LTE_Manager_Logs"},
  ];
  const handleDownloadClick = async (command) => {
    setdownloadLoadingStatus(true)
    let response = await dispatch(downloadRecMenulogs(token, boxDetails._id,command?.value)) || '';
    //  if (!response || !response.data || response.data.size === 0) {
    //   toast.error('Something went wrong')
    //   return;
    //  }
    if (!response || !response.data || response.data.size === 0) {
      toast.error(command.name === "lte_manager_log" ? "No log available" : "Something went wrong");
      setdownloadLoadingStatus(false)
      return;
    }
      setdownloadLoadingStatus(false)
      const url = window.URL.createObjectURL(new Blob([response.data])) || '';
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${command?.downloadName}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);
  }
  let commandItem = item.find(cmd => cmd.name === selectedCommand?.name) ||
    item.find(cmd => cmd.name === recSubCommand?.name);

  const renderRunCommand = (
    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      {isPreparingDownload && (
        <div style={{ 
          padding: '6px 12px', 
          backgroundColor: '#e3f2fd', 
          borderRadius: '4px',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          whiteSpace: 'nowrap'
        }}>
          <LoadingIcon width={16} height={16} />
          <span style={{ color: '#1976d2', fontWeight: 500, fontSize: '14px' }}>
            Preparing download file...
          </span>
        </div>
      )}
      {commandItem && (
        <span className="download-button-container">
          {downloadLoadingStatus ? (
            <div className="spinner-container">
              <SpinnerCircles red />
            </div>
          ) : (
            <TooltipIcon
              tipId="downloadLogs"
              onClick={() => handleDownloadClick(commandItem)}
              imgSrc={runDiagnosticLogo}
              displayData="Download Logs"
              placement="top"
              className="download-tooltip-icon"
            />
          )}
        </span>
      )}
      <Button color="primary" onClick={() => onRunCommand()}>
        Execute
      </Button>
   </div>
  );

  const addActivityLogForCommands = (activityLogCommands, command, recSubCommand) => {
    //we can add more commands for activity logging here that needs dynamc check; like Epi Ata controls 1,2,3,4 etc.
    const forDynamicIncreasingCommands = ['EPI controls ATA']
    const isDynamicMatch = forDynamicIncreasingCommands.some(prefix => command?.startsWith(prefix));

    for (let key in activityLogCommands) {
      if (typeof activityLogCommands[key] === 'object' && (key === command || isDynamicMatch) ) {
        addActivityLogForCommands(activityLogCommands[key], command , recSubCommand);
      } else {
        const cmd = recSubCommand ? recSubCommand : command
        if (key === cmd) {
          addNote({ 
            boxID: boxDetails._id, 
            note: `REC ${activityLogCommands[key]} ${isDynamicMatch ? `- ${command}` : ''}`
          });          
          return;
        }
      }
    }
  };

  const onConfirmRce = () => {
    // onRceDiagnostics();
    setIsFsCli(false)
    // setModalStatus(false);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const { _id } = boxDetails;
      const report = await dispatch(fetchDiagnosticReport(token, _id));
      if (Array.isArray(report)) setDiagRes(report);
      else setnoDiagLogs(report);

      setIsLoading(false);
      setIsWatchGuardLoading(true);

      const watchGuard = await dispatch(checkWatchguardIsActive(token, _id));
      
      const isActive = (watchGuard === 'active' || (watchGuard?.includes('watchGuard running'))) && report
      setWatchguardCheck(isActive);
      setIsWatchGuardLoading(false);
    })();
  }, [fetchTest]);

  const onFetchResults = async () => {
    setFetchTest(!fetchTest);
  };

  const onRefreshResults = async () => {
    (async () => {
      setIsLoading(true);
      const { _id } = boxDetails;
      await dispatch(refreshDiagnosticResults(token, _id));
      setIsLoading(false);
    })();
  };
  const setRecOff = () => {
    // const serialNumberDash = isFsCli ? serialNumberDashVSwitch : serialNumberDash
    stateSocket.emit('RCE', {
      serialNumber: serialNumberDash,
      ip: boxDetails.vpnAddress,
      cleanup: true,
    });
    setIsFsCli(null);
    setCommandDataList([]);
    setRceModal(false);
    setSelectedCommand('')
    testingArray = []
    testingObject = {};
    selectedCmd = ''
    
    // Clear any pending download timeouts and reset download data
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
      downloadTimeoutRef.current = null;
    }
    downloadDataRef.current = {};
    setIsPreparingDownload(false);
    setPreparingDownloadCommand('');
  };
  const onRestartWatchguard = async () => {
    (async () => {
      setIsLoading(true);
      const { _id } = boxDetails;
      const restarted = await dispatch(restartWatchguard(token, _id));

      setWatchguardCheck(restarted);
      setIsLoading(false);
    })();
  };

  const isFailoverCommands = (command) => FAILOVER_COMMANDS.includes(command)
  const renderFailoverData = (data, command) => {
    let split = command == 'lte_24_hour_log' ? '\\n' : '\n'
    return data?.split(split).map((output, index) => <span style={{ display: 'block', marginTop: 5 }}>{output}</span>)
  }
  // const scrollHandler = () => {
  //   scrollBottom ?
  //     endRef.current.scrollIntoView({ behavior: 'smooth' }) :
  //     startRef.current.scrollIntoView({ behavior: 'smooth' });
  //   setScrollBottom(!scrollBottom)
  // }
const scrollHandler = () => {
  if (scrollBottom) {
    if (endRef.current) {
      endRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  } else {
    if (startRef.current) {
      startRef.current.scrollIntoView({ behavior: 'smooth' });
    } 
  }
  setScrollBottom(!scrollBottom); 
};

useEffect(() => {
  if (!recParentRef?.current) return; 
  const resizeObserver = new ResizeObserver(() => {
    if (recParentRef.current && recParentRef.current.clientHeight > 620) {
      if (!showScrollBtn) setShowScrollBtn(true); 
    } else {
      if (showScrollBtn) setShowScrollBtn(false); 
    }
  });
  resizeObserver.observe(recParentRef.current);
  return () => resizeObserver.disconnect();
}, [showScrollBtn, setShowScrollBtn]);

// Cleanup timeout on component unmount
useEffect(() => {
  return () => {
    if (downloadTimeoutRef.current) {
      clearTimeout(downloadTimeoutRef.current);
      downloadTimeoutRef.current = null;
    }
    downloadDataRef.current = {};
  };
}, []);
const cleanOutput = (output) =>
  stripAnsi(String(output || ''))       
    .replace(/[^\x20-\x7E\n\r\t]/g, '');

  const formatJSON = (value) => {
    try {
      return JSON.stringify(
        typeof value === 'string' ? JSON.parse(value) : value,
        null,
        2
      );
    } catch (e) {
      return value;
    }
  };
  return isLoading ? (
    <div className="error-msg d-flex flex-column justify-content-center align-items-center">
      <img src={logoLoading} className="loading-logo-sm" alt="loading" />
      <p className="text-align-center">Loading, Please wait...</p>
    </div>
  ) : (
    <div className=" ">
      <Row >
      <ScrollToBottom className="diagnostics-data-container">
        <Row>
          <Col md={12} ref={messageRef}>
            {Array.isArray(diagRes) &&
              diagRes.length > 0 &&
              diagRes?.map(item => {
                const lastResult = item.value.trimStart();
                return (
                  <Row
                    className={item?.key === 'Timestamp' ? 'list-item timestamp-head' : 'list-item'}
                    style={{
                      backgroundColor:
                        (lastResult === 'PASS' && '#008000') ||
                        (lastResult === 'PASS (After fix attempt)' && '#90EE90') ||
                        (lastResult === 'FAIL' && '#FFFF00') ||
                        (lastResult === 'FAIL (After fix attempt)' && '#FF0000') ||
                        (lastResult === 'fixed' && '#008000') ||
                        (lastResult === 'running' && '#ADD8E6'),
                    }}
                  >
                    <Col md={item?.key === 'Timestamp' ? 7 : 12} className="right-container">
                      <h1
                        style={{
                          color: lastResult === 'failed' && '#FFFFFF',
                          alignSelf: 'center',
                        }}
                      >
                        {`${item.key} : `}
                        <span style={item?.key === 'Timestamp' && utils.isOlderThan24Hours(lastResult) ? { color: 'red', fontWeight: 500 } : {}}>
                          {item.key == 'Timestamp' ? utils.getDateTimeFormat(lastResult,'both') : lastResult}
                        </span>
                      </h1>
                    </Col>
                    {item?.key === 'Timestamp' && (
                      <Col md={5} className="right-container">
                        {watchguardCheck || isWatchguardLoading ? (
                          isWatchguardLoading ? (
                            <LoadingIcon width={30} height={30} />
                          ) : (
                            'Diagnostics Service Running'
                          )
                        ) : (
                          <Button
                            color="danger"
                            className="fetch-tests"
                            onClick={() => onRestartWatchguard()}
                          >
                            Restart Diagnostics Service
                          </Button>
                        )}
                      </Col>
                    )}
                  </Row>
                );
              })}
            {(!Array.isArray(diagRes) || diagRes.length === 0) && (
              <>
                <Row className="list-item timestamp-head">
                  <Col md={7} className="right-container" />
                  <Col md={5} className="right-container">
                    {watchguardCheck ? (
                      'Diagnostics Service Running'
                    ) : (
                      <Button
                        color="danger"
                        className="fetch-tests"
                        onClick={() => onRestartWatchguard()}
                      >
                        Restart Diagnostics Service
                      </Button>
                    )}
                  </Col>
                </Row>
                <div className="diagnostic-no-logs">
                  <h1>{noDiagLogs || 'No Data Found'}</h1>
                </div>
              </>
            )}
          </Col>
        </Row>
      </ScrollToBottom>
      </Row>
      <div className='row'>
  <div class="connectionButtonsContainer">
    <div>
      {/* fail-over options */}
    {user.permissionsGroup === 'Engineering' &&(
      <TooltipIcon
        tipId="add-time-failOver"
        onClick={() => {
          const el = document.getElementById('test-time-remaining');
          const hidden = el?.getAttribute('hidden') !== null;
          if (lockStatusBox?.locked) {
            toast.error(DEVICE_LOCK_BY_SOMEONE);
            return;
          }
          if (hidden) {
            setDcUpdatePopup({ show: true });
          } else {
            // setIsFailoverOpen(true);
            openFailoverWithData();
          }
        }}
        imgSrc={interfaceFailOver}
        displayData="Failover Options"
        placement="top"
      />
    )}
      {/* fail-over options */}
      {(recDiagnostics === 'write' || recDiagnostics === 'both') && (
        <TooltipIcon
          tipId="add-time-icons"
          onClick={() => {
            const divElement = document.getElementById('test-time-remaining');
            const isHidden = divElement.getAttribute('hidden') !== null;
            if(lockStatusBox?.locked){
              toast.error(DEVICE_LOCK_BY_SOMEONE)
            }else{
              if (isHidden) {
                setDcUpdatePopup({ show: true });
              } else {
                  onConfirmRce();
                  setRceModal(true);
               }
            }
          }}
          imgSrc={recButtonLogo}
          displayData="Remote Execution Center"
          placement="top"
        />
      )}

      <TooltipIcon
        tipId="add-time-iconssss"
        onClick={() => {
          setIsFsCli(true);
          setModalStatus(true)
        }}
        imgSrc={vSwitchLogo}
        displayData="vSwitch Output"
        placement="top"
      />
    </div>

    {(nocWizardAccess === 'write' || nocWizardAccess === 'both') &&(
      <TooltipIcon
        tipId="nocLogo"
        onClick={() => {
          window.open(REACT_APP_NOCWIZARD_SERVER ? `${REACT_APP_NOCWIZARD_SERVER}?serialNumber=${boxDetails?.serialNumber}` : '', 'blank');
        }}
        imgSrc={nocLogo}
        displayData="NOC Output"
        placement="top"
      />
    )}

    {boxDetails?.vpnAddress && utils.checkBoxVersionThirdOctet(boxDetails?.vpnAddress) !== 'v2' && (
      <span className="cdm-info">
        <strong>Last CDM Check: </strong>
        {isStatusLoading ? (
          <LoadingIcon width={30} height={30} />
        ) : (
          <span>
            <span style={deviceStatus && deviceStatus['Last CDM Check'] && utils.isOlderThan24Hours(deviceStatus['Last CDM Check']) ? { color: 'red', fontWeight: 500 } : {}}>
              {(deviceStatus &&
                deviceStatus?.Status === 'Online' &&
                utils.getDateTimeFormat(deviceStatus['Last CDM Check'], 'both')) ||
                deviceStatus && deviceStatus['Last CDM Check'] ||
                '-'}
            </span>
          </span>
        )}
      </span>
    )}

    <span style={{ 'padding-right': '50px' }}>
      <TooltipIcon
        tipId="add-time-iconsss"
        onClick={() => {
          onFetchResults();
        }}
        imgSrc={runDiagnosticLogo}
        displayData="Download Results"
        placement="top"
      />
    </span>
           
    <TooltipIcon
      tipId="add-time-icon"
      onClick={() => {
        onRefreshResults();
      }}
      imgSrc={fetchLogo}
      displayData="Query Device for Real-Time Details"
      placement="top"
    />
  </div>
</div>
        {rceModal && (
          <CustomModal
            header={isFsCli ? null : renderCommandList}
            isOpen={rceModal}
            closeHeader={isFsCli ? null : renderRunCommand}
            onCancel={setRecOff}
            wider
            customBodyClass={'position-static'}
            recParentRef={recParentRef}
            setShowScrollBtn={setShowScrollBtn}
            showScrollBtn={showScrollBtn}
          >
            <div ref={recParentRef}>
              <div ref={startRef} />
              {commandDataList.length === 0 && !sideBySideData.dc && !sideBySideData.wg ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                  {recLoading ? <LoadingIcon width={50} height={50} /> : <h1>No Data to display</h1>}
                </div>
              ) : (
                <>
                  {commandDataList.map((item, idx) => {
                    const isModemVerbose = item.command === 'modem_verbose';
                    // const str = item?.output ? item.output.toString() : '';
                    const str = item?.output ? cleanOutput(item?.output) : "" 
                    const xml = str.search('<include>') !== -1;
                    if (item.command !== 'side_by_side_ping_dc' && item.command !== 'side_by_side_ping_wg') {
                      return (
                        <>
                          <h1 className="log-heading">{item.label}</h1>
                          {xml ? (
                            <XmlViewer xml={str} />
                          ) : isFailoverCommands(item?.command) ? (
                            <div>{renderFailoverData(item.output, item.command)}</div>
                          ) : isModemVerbose ? (
                            <div className="modemJsonBox">
                              <pre>{formatJSON(item.output)}</pre>
                            </div>
                          ) : (
                            <pre>{str}</pre>
                          )}
                        </>
                      );
                    }
                    if (sideBySideData)
                      return (
                        <Row className="side-by-side-row">
                          <Col md={6} className="side-by-side-col">
                            <h3 className="ping-header">{selectedCmd === 'lte_and_eth0_side_by_side' ? 'Eth0' : 'Data Center'}</h3>
                            <pre>{sideBySideData.dc}</pre>
                          </Col>
                          <Col md={6} className="side-by-side-col">
                            <h3 className="ping-header">{selectedCmd === 'lte_and_eth0_side_by_side' ? 'wwan0' : 'WireGuard'}</h3>
                            <pre>{sideBySideData.wg}</pre>
                          </Col>
                        </Row>
                      );
                    else return null
                  })}
                </>
              )}
              <div ref={endRef} />
              <Button color="primary" onClick={onClearRce} style={{ position: 'absolute', bottom: 15 }}>
                Clear data
              </Button>
              {showScrollBtn && (
                <p onClick={scrollHandler} className="scroll-btn">
                  <FontAwesomeIcon
                    icon={scrollBottom ? faAngleDown : faAngleUp}
                    color="#00000070"
                    style={{ fontSize: 20, marginTop: 3 }}
                  />
                </p>
              )}
            </div>
          </CustomModal>
        )} 

      <AddSecurityCodeModal
          isOpen={modalStatus && !isFsCli}
        onCancel={() => {
          setModalStatus(!modalStatus);
          setIsFsCli(null);
        }}
        onConfirm={onConfirmRce}
        rceSecurity
        featureName={'rceSecurity'}
      />
      <ConfirmationModal
        bodyText={'You are attempting to make changes to a device that is not currently locked for editing. To prevent conflicting changes, please lock the device before proceeding.'}
        headerText={'Device Lock Required'}
        confirmBtnText={'Lock & Edit'} 
        close={'No'} 
        isOpen={dcUpdatePopup.show}
        onCancel={() => {
          setDcUpdatePopup({ show: false, value: {} });
        }}
        onConfirm={() => {
          unLockBoxButton();
          setDcUpdatePopup({ show: false, value: {} });
        }}
      />
        <FailoverOptionsModalClassic
          isOpen={isFailoverOpen}
          onClose={() => setIsFailoverOpen(false)}
          onRefresh={onRefreshFailOverOptions}
          failOverOptionsData={foData.loading ? {} : foData.failOverOptions}
          boxDetails={boxDetails}
        />
    </div>
  );
};

export default Diagnostics;
